import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
let store = new Vuex.Store({
  state: {
    item: [{
        icon: 'el-icon-lx-home',
        index: 'dashboard',
        title: '数据统计'
      },
      {
        icon: 'el-icon-lx-cascades',
        index: 'merchants-Manage',
        title: '商户管理',
      },
      {
        icon: 'el-icon-lx-copy',
        index: 'order',
        title: '交易明细'
      },
      {
        icon:'el-icon-bell',
        index: 'voice',
        title:'语音播报'
      }
    ],

  },
  getters: {
    getItem(state) {
      return state.item;
    },
  },
  actions: {
    setItemName({
      commit,
      state
    }, name) {
      commit("setItem", name);
    },
  },

  mutations: {
    setItem(state, name) {
      state.item = name; //将传参设置给state的city
    }
  }
});

export default store;